import React from "react";
import { useTranslation } from "react-i18next";

const TermsAndConditionsIECContent = ({selectedCountry}) => {

  const { t } = useTranslation("common");

        return (
           <div className="modalContentPadding">
            <p>{t(`${selectedCountry}.paragraph1`)}</p>
            <p>{t(`${selectedCountry}.paragraph2`)}</p>
            <p>{t(`${selectedCountry}.paragraph3`)}</p>
            <p>{t(`${selectedCountry}.paragraph4`)}</p>
            <p>{t(`${selectedCountry}.paragraph5`)}</p>
          </div>
        )
      }

export default TermsAndConditionsIECContent;
